import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ClearStorageView = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const clearData = async () => {
      // Clear local/session storage
      localStorage.clear();
      sessionStorage.clear();

      // Clear Cache Storage (Service Worker caches)
      if ("caches" in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((name) => caches.delete(name)));
      }

      // Unregister service workers (optional)
      if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(
          registrations.map((registration) => registration.unregister())
        );
      }

      navigate("/", { replace: true });
    };

    clearData();
  }, [navigate]);

  return <div>Clearing application data...</div>;
};

export default ClearStorageView;